<template>
  <div class="cso-textarea-simple"
       :class="{'is-error': validationErrors}">
    <div class="cso-textarea-wrapper">
      <label v-if="label"
            :for="name">
        {{ label }}
      </label>
      <textarea :id="name"
                :name="name"
                :validation-name="validationName"
                :rows="rows"
                :cols="cols"
                :maxlength="maxlength"
                autocomplete=""
                :data-cy="cypressName"
                v-model="currentValue"
                @input="onInput"
                @blur="onBlur"
                :placeholder="placeholder"></textarea>
      <span class="form-textarea-charRemaining"
            v-if="realCountChars && !validationErrors">
        <span class='form-textarea-charchount js-textarea-charcount' 
              :data-cy="counterCypressName">{{currentValue.length}} / {{ maxlength }}</span>
      </span>
    </div>
    <div class="cso-input-errors-wrapper"
         v-if="validationErrors">
      <div v-for="(error, index) in validationErrors"
           class="cso-input-error"
           v-html="error.message"
           :key="index">
      </div>
    </div>
  </div>
</template>
<script>
import validatedInputField from '@/mixins/validatedInputField'

export default {
  name: 'CsoTextareaSimple',
  mixins: [validatedInputField],
  props: {
    countCharsLeft: {
      type: String,
      required: false,
      default: 'false'
    },
    maxlength: {
      type: String,
      required: false
    },
    rows: {
      type: String,
      required: false
    },
    cols: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false
    },
    cypressName: {
      type: String,
      required: false
    },
    counterCypressName: {
      type: String,
      required: false
    }
  },

  computed: {
    realCountChars: function () {
      return (!!this.countCharsLeft && this.countCharsLeft !== 'false') && !!this.maxlength
    }
  }
}
</script>
<style lang="scss">
.cso-textarea-simple {
  margin-top: 16px;
  margin-bottom: 16px;

  &.is-error textarea {
    border: 1px solid $error;
  }

  &[disabled=true] {
    display: none;
  }

  label {
    position: absolute;
    margin: -8px 8px;
    background-color: $white;
    padding: 0 4px;
    font-size: 14px;
  }

  textarea {
    width: 100%;
    min-width: 100%;
    max-width: 100%;
    min-height: 48px;
    font-size: 16px;
    line-height: 24px;
    padding: 12px;
    border: 1px solid $gray-4d;
    font-family: $font-family-regular;
    outline: 0;

    &:focus {
      outline: 2px solid $blue;
      outline-offset: 2px;
    }
  }

  .form-textarea-charRemaining {
    text-align: left;
  }
}
</style>
